import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DeficiencyDetail from './DeficiencyDetail';
export default function DeficiencyShow({ deficiencyId, inspectionId, deficiencyStatuses, tags }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(DeficiencyDetail, { deficiencyId: deficiencyId, inspectionId: inspectionId, deficiencyStatuses: deficiencyStatuses, tags: tags })));
}
